/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import get from 'lodash/get';
import {
  Text,
  RichText,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import { Container, Row } from '../../../styles/Grid';
import OffsetColumn from '../../ui/OffsetColumn';
import { Icon } from '../../ui/Icon';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  contentCss,
  titleCss,
  titleLabelCss,
  chevronCss,
  chevronRotatedCss,
  richTextCss,
} from './index.styles';

export class AccordionSection extends SafePureComponent {
  constructor(props) {
    super(props);
    this.pageEditing = get(props, 'sitecoreContext.pageEditing', false);
    this.state = {
      isOpen: this.pageEditing,
    };
  }

  static propTypes = {
    fields: PropTypes.shape({
      SectionTitle: PropTypes.any,
      SectionBody: PropTypes.any,
    }),
  };

  renderButton() {
    const { fields } = this.props;
    const { isOpen } = this.state;

    if (!fields) {
      return;
    }

    if (this.pageEditing) {
      return (
        <div css={titleCss}>
          <span css={titleLabelCss}>
            <Text field={fields.SectionTitle} />
          </span>
        </div>
      );
    }

    return (
      <button
        data-testid="title-button"
        css={titleCss}
        onClick={this.toggleAccordion}
      >
        <span css={titleLabelCss}>
          <Text field={fields.SectionTitle} />
        </span>
        <Icon
          customCss={[chevronCss, isOpen && chevronRotatedCss]}
          name="chevron-down"
        />
      </button>
    );
  }

  toggleAccordion = () => {
    if (this.pageEditing) {
      return;
    }
    this.setState({ isOpen: !this.state.isOpen });
  };

  safeRender() {
    const { fields } = this.props;
    const { isOpen } = this.state;
    const hideSpacer = get(this.props, 'params.hideSpacer', false);

    if (hideSpacer) {
      return (
        <div data-item={'accordion-section'} css={contentCss}>
          {this.renderButton()}
          {isOpen && (
            <div data-testid="body-section" css={richTextCss}>
              <RichText field={fields.SectionBody} />
            </div>
          )}
        </div>
      );
    }

    return (
      <Container>
        <Row>
          <OffsetColumn
            cols={{ sm: 6, md: 7, lg: 8 }}
            offsets={{ md: 1, lg: 1, xl: 1 }}
          >
            <div data-item={'accordion-section'} css={contentCss}>
              {this.renderButton()}
              {isOpen && (
                <div data-testid="body-section" css={richTextCss}>
                  <RichText field={fields.SectionBody} />
                </div>
              )}
            </div>
          </OffsetColumn>
        </Row>
      </Container>
    );
  }
}

AccordionSection.displayName = 'AccordionSection';

export default withSitecoreContext()(AccordionSection);
